<style lang="scss">
.udropdowncontainer {
  position: relative;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-weight: bold;
  width: auto !important;

  border: 0 !important;

  color: $c-dark-grey !important;

  .label {
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    border: 0 !important;
  }

  ul {
    //width: 100%;
    z-index: 10;

    position: absolute;
    left: -1px;
    top: 100%;
    transform: translateY(4px);
    padding: 0;

    //border: 1px solid black;

    padding: 0;
    li {
      min-width: 300px;
      margin-top: 2px;
      background-color: #fff !important;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      border: 0 !important;
      border-bottom: 3px solid $c-blue !important;
    }
  }
}
</style>

<template>
  <div class="udropdowncontainer">
    <div class="label" @click.stop="onClick">{{ label }}</div>
    <ul v-if="open">
      <li class="button" :key="user.id" v-for="user of labels" @click="onSelect(user)">{{ user.name }}</li>
    </ul>
    <Icon :path="mdiMenuDown" :width="15" @click.stop="onClick" />
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import { mdiMenuDown } from '@mdi/js';
import { Emitter } from 'mitt';

interface UserRecord {
  id: number;
  username: string;
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  unit_id: number;
  notiz: string;
  files: string;
  hidden: boolean;
  data: any;
}

export default defineComponent({
  props: {
    users: { type: Array as PropType<Array<UserRecord>>, default: () => [] },
    withbackevent: { type: Boolean, default: false },
  },
  emits: ['changed', 'opened', 'closed'],
  setup(props, { emit }) {
    const store = useStore();
    const open = ref(false);
    const label = ref('Details');
    const labels = ref<Array<{ name: string; id: number }>>([]);

    const mitt = inject('emitter') as Emitter<{ closedropdowns: string }>;
    const mitt2 = inject('emitter') as Emitter<{ awayfromdetails: string }>;

    mitt.on('closedropdowns', () => {
      open.value = false;
      emit('closed');
    });

    onMounted(() => {
      if (props.withbackevent) {
        labels.value.push({
          name: `Details`,
          id: -1,
        });
      }

      for (const user of props.users) {
        labels.value.push({
          name: `${user.firstname} ${user.lastname}`,
          id: user.id,
        });
      }
    });

    mitt2.on('awayfromdetails', () => {
      label.value = 'Details';
      open.value = false;
    });

    const onClick = () => {
      if (open.value) {
        mitt.emit('closedropdowns', '');
        open.value = false;
        emit('closed');
      } else {
        mitt.emit('closedropdowns', '');
        open.value = true;
        emit('opened');
      }
    };

    const onSelect = (user: { name: string; id: number }) => {
      mitt.emit('closedropdowns', '');
      emit('changed', user.id);
      label.value = user.name;
    };
    return {
      open,
      label,
      mdiMenuDown,
      onClick,
      onSelect,
      labels,
    };
  },
});
</script>
